import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useLocation } from "wouter";
import logoImage from "@assets/legacyloop-white-trans.png";
import { useState } from "react";

export default function ComingSoon() {
  const [, setLocation] = useLocation();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<{text: string, type: 'success' | 'error'} | null>(null);
  
  const handleWaitlistSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    
    setSubmitting(true);
    setMessage(null);
    
    try {
      const response = await fetch('/api/waitlist', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      if (response.ok) {
        setMessage({
          text: "You've been added to our waitlist. We'll notify you when we launch.",
          type: 'success'
        });
        setEmail("");
      } else {
        const error = await response.json();
        if (error.message === "Email already in waitlist") {
          setMessage({
            text: "You're already on our waitlist. We'll notify you when we launch.",
            type: 'success'
          });
        } else {
          throw new Error(error.message || "Failed to join waitlist");
        }
      }
    } catch (error: any) {
      setMessage({
        text: error.message || "Something went wrong. Please try again.",
        type: 'error'
      });
    } finally {
      setSubmitting(false);
    }
  };
  
  return (
    <div className="min-h-screen bg-[#0D1B2A] text-white font-sans flex flex-col items-center justify-center p-6 text-center">
      <img src={logoImage} alt="LegacyLoop" className="h-24 w-auto mb-6" />
      
      <h1 className="text-4xl font-bold mb-4">Coming Soon</h1>
      <p className="text-lg text-slate-300 max-w-xl mx-auto mb-8">
        We're working hard to bring you this feature. Check back soon!
      </p>
      
      <div className="w-full max-w-md mb-8">
        <h2 className="text-xl font-medium mb-4">Join our waitlist</h2>
        <p className="text-slate-300 mb-4">
          Be the first to know when this feature becomes available.
        </p>
        
        <form onSubmit={handleWaitlistSubmit} className="flex flex-col gap-3">
          <div className="flex gap-2">
            <Input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-[#1B263B] border-[#415A77] text-white"
            />
            <Button 
              type="submit"
              className="bg-[#E0A458] text-black hover:bg-[#f0b467] whitespace-nowrap"
              disabled={submitting}
            >
              {submitting ? "Joining..." : "Join Waitlist"}
            </Button>
          </div>
          
          {message && (
            <div className={`text-sm mt-2 ${message.type === 'success' ? 'text-green-400' : 'text-red-400'}`}>
              {message.text}
            </div>
          )}
        </form>
      </div>
      
      <Button 
        className="bg-[#1B263B] text-white hover:bg-[#415A77]"
        onClick={() => setLocation("/")}
      >
        Return to Homepage
      </Button>
    </div>
  );
}